import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
  },
  imageUploadContainer: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(1),
  },
  imageForm: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  companyImage: {
    height: "97px",
    width: "97px",
  },
  imageDetails: {
    flex: 1,
    marginLeft: "2rem",
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1),
  },
}));
